"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var turfBbox = require("@turf/bbox");
var lat2y_1 = require("./lat2y");
var lng2x_1 = require("./lng2x");
/**
 * Get the biggest z value of a possible tile that covers a bounding box according the the given maximal z value.
 */
function getCoveringZFromBBox(bbox, maxZ) {
    var width = Math.abs(lng2x_1.lng2x(bbox.minLng, maxZ) - lng2x_1.lng2x(bbox.maxLng, maxZ));
    if (width !== 0) {
        return getCoveringZFromBBox(bbox, maxZ - Math.ceil(Math.log(width) / Math.log(2)));
    }
    var height = Math.abs(lat2y_1.lat2y(bbox.minLat, maxZ) - lat2y_1.lat2y(bbox.maxLat, maxZ));
    if (height !== 0) {
        return getCoveringZFromBBox(bbox, maxZ - Math.ceil(Math.log(height) / Math.log(2)));
    }
    return maxZ;
}
exports.getCoveringZFromBBox = getCoveringZFromBBox;
/**
 * Get the tile coordinates that covers the given bbox and maximal z value.
 */
function getCoveringTileFromBBox(bbox, maxZ) {
    var z = getCoveringZFromBBox(bbox, maxZ);
    return {
        x: lng2x_1.lng2x(bbox.minLng, z),
        y: lat2y_1.lat2y(bbox.minLat, z),
        z: z,
    };
}
exports.getCoveringTileFromBBox = getCoveringTileFromBBox;
/**
 * Get the tile coordinates that covers the given GeoJSON and maximal z value.
 */
function getCoveringTileFromGeoJSON(geoJSON, maxZ) {
    var _a = turfBbox(geoJSON), minLng = _a[0], minLat = _a[1], maxLng = _a[2], maxLat = _a[3];
    return getCoveringTileFromBBox({ minLng: minLng, minLat: minLat, maxLng: maxLng, maxLat: maxLat }, maxZ);
}
exports.getCoveringTileFromGeoJSON = getCoveringTileFromGeoJSON;
//# sourceMappingURL=covering-tile.js.map